import React from 'react';

import { useIntl } from 'react-intl';

import SubTabs from 'components/sub-tabs';
import { UserType } from 'types/shared/user-type.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
  userType?: string;
};

enum Tabs {
  GENERAL = 'general',
  CONTACT_DETAILS = 'contact-details',
  SILO_MANAGEMENT = 'inventory-silo-management',
}

const ViewSiteTabsHeader: React.FC<Props> = ({ userType }) => {
  const intl = useIntl();

  return (
    <SubTabs
      sx={{
        marginLeft: -3,
      }}
      tabs={[
        {
          label: intl.formatMessage({ id: 'siteSettings.navigation.inventorySiloManagement' }),
          value: Tabs.SILO_MANAGEMENT,
        },
        {
          label: intl.formatMessage({ id: 'siteSettings.navigation.generalSettings' }),
          value: Tabs.GENERAL,
          hide: userType !== UserType.SuperUser && userType !== UserType.Cargill,
        },
        {
          label: intl.formatMessage({ id: 'siteSettings.navigation.contactDetails' }),
          value: Tabs.CONTACT_DETAILS,
        },
      ]}
    />
  );
};

export default React.memo(ViewSiteTabsHeader);
